export const LOGIN_EVENT = 'login';

export interface LoginEventData {
  consultantId: number;
  event: typeof LOGIN_EVENT;
  loginType: string | null;
}
